const reportTheme = {
  id: 307,
  name: "Stacked Bar",
  slug: "stacked-bar",
  title: null,
  description: null,
  clientID: 1,
  use_for_summary: false,
  allow_for_custom: false,
  country: "England",
};

const items = [
  {
    id: 2547,
    reportThemeID: 307,
    text: null,
    chartType: "Stacked Bar",
    chartRef: "17274229378853",
    chartDescription: "Stacked Drug crime offences (mock categories)",
    chartXLabel: null,
    chartYLabel: "Offences (12m total)",
    syncChartWithHTMLTableRef: null,
    inverseChartData: true,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 1,
    timeSeries: false,
    itemName: "Drug crime offences (stacked)",
    itemSource: "Police UK (mock)",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    // For stacked bar, provide multiple indicators representing categories to stack
    indicators: [
      {
        id: 9001,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_possession_12m",
        indicatorDate: "2023-12-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1,
        indicatorName: "Possession offences (rolling 12 months)",
        source: "Police UK",
        date: "2023-12-01",
        decimalPlaces: 0,
        dateCoverageText: "Dec-2023",
      },
      {
        id: 9002,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_trafficking_12m",
        indicatorDate: "2023-12-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 2,
        indicatorName: "Trafficking/ supply offences (rolling 12 months)",
        source: "Police UK",
        date: "2023-12-01",
        decimalPlaces: 0,
        dateCoverageText: "Dec-2023",
      },
      {
        id: 9003,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378853",
        indicatorCode: "drugs_other_12m",
        indicatorDate: "2023-12-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 3,
        indicatorName: "Other drug offences (rolling 12 months)",
        source: "Police UK",
        date: "2023-12-01",
        decimalPlaces: 0,
        dateCoverageText: "Dec-2023",
      },
    ],
  },
  {
    id: 2548,
    reportThemeID: 307,
    text: null,
    chartType: "Stacked Bar",
    chartRef: "17274229378854",
    chartDescription: "Employment by sector (stacked)",
    chartXLabel: null,
    chartYLabel: "Number of employees (thousands)",
    syncChartWithHTMLTableRef: null,
    inverseChartData: false,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 2,
    timeSeries: false,
    itemName: "Employment by sector",
    itemSource: "Office for National Statistics (ONS)",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 9004,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "employment_public_sector",
        indicatorDate: "2023-12-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1,
        indicatorName: "Public sector employment",
        source: "ONS",
        date: "2023-12-01",
        decimalPlaces: 1,
        dateCoverageText: "Dec-2023",
      },
      {
        id: 9005,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "employment_private_sector",
        indicatorDate: "2023-12-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 2,
        indicatorName: "Private sector employment",
        source: "ONS",
        date: "2023-12-01",
        decimalPlaces: 1,
        dateCoverageText: "Dec-2023",
      },
      {
        id: 9006,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378854",
        indicatorCode: "employment_self_employed",
        indicatorDate: "2023-12-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 3,
        indicatorName: "Self-employed",
        source: "ONS",
        date: "2023-12-01",
        decimalPlaces: 1,
        dateCoverageText: "Dec-2023",
      },
    ],
  },
  {
    id: 2549,
    reportThemeID: 307,
    text: null,
    chartType: "Stacked Bar",
    chartRef: "17274229378855",
    chartDescription: "Population by age group (stacked)",
    chartXLabel: null,
    chartYLabel: "Population (thousands)",
    syncChartWithHTMLTableRef: null,
    inverseChartData: false,
    chartXCommaSeperatedValues: null,
    chartYCommaSeperatedValues: null,
    indicatorHTMLTableRef: null,
    HTMLTableType: 1,
    indicatorHTMLTableDescription: null,
    domainHTMLTableColOneText: null,
    domainHTMLTableColTwoText: null,
    order: 3,
    timeSeries: false,
    itemName: "Population by age group",
    itemSource: "UK Census 2021",
    showComparators: true,
    kpi_config: null,
    display_data_point_markers: false,
    indicators: [
      {
        id: 9007,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378855",
        indicatorCode: "pop_0_17",
        indicatorDate: "2021-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 1,
        indicatorName: "Aged 0-17",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 1,
        dateCoverageText: "2021",
      },
      {
        id: 9008,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378855",
        indicatorCode: "pop_18_64",
        indicatorDate: "2021-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 2,
        indicatorName: "Aged 18-64",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 1,
        dateCoverageText: "2021",
      },
      {
        id: 9009,
        indicatorHTMLTableRef: null,
        chartRef: "17274229378855",
        indicatorCode: "pop_65_plus",
        indicatorDate: "2021-01-01",
        chartColour: null,
        domainHTMLTableColTwo: false,
        order: 3,
        indicatorName: "Aged 65+",
        source: "Census 2021",
        date: "2021-01-01",
        decimalPlaces: 1,
        dateCoverageText: "2021",
      },
    ],
  },
];

const comparatorAreaCodes = ["CSTM5160", "E10000012", "E10000011"];

const comparatorsList = [
  { area_code: "CSTM5160", area_name: "Comparator 1" },
  { area_code: "E10000012", area_name: "Comparator 2" },
  { area_code: "E10000011", area_name: "Comparator 3" },
];

// Indicator values for all stacked bar chart examples
// Key pattern: <area>.<indicatorCode>.<date>.<indicatorName>
const indicatorValues = {
  // Example 1: Drug crime offences (stacked)
  "CSTM5160.drugs_possession_12m.2023-12-01.Possession offences (rolling 12 months)":
    "450",
  "E10000012.drugs_possession_12m.2023-12-01.Possession offences (rolling 12 months)":
    "15000",
  "E10000011.drugs_possession_12m.2023-12-01.Possession offences (rolling 12 months)":
    "3200",

  "CSTM5160.drugs_trafficking_12m.2023-12-01.Trafficking/ supply offences (rolling 12 months)":
    "220",
  "E10000012.drugs_trafficking_12m.2023-12-01.Trafficking/ supply offences (rolling 12 months)":
    "8200",
  "E10000011.drugs_trafficking_12m.2023-12-01.Trafficking/ supply offences (rolling 12 months)":
    "1700",

  "CSTM5160.drugs_other_12m.2023-12-01.Other drug offences (rolling 12 months)":
    "130",
  "E10000012.drugs_other_12m.2023-12-01.Other drug offences (rolling 12 months)":
    "4600",
  "E10000011.drugs_other_12m.2023-12-01.Other drug offences (rolling 12 months)":
    "900",

  // Example 2: Employment by sector (stacked)
  "CSTM5160.employment_public_sector.2023-12-01.Public sector employment":
    "45.2",
  "E10000012.employment_public_sector.2023-12-01.Public sector employment":
    "180.5",
  "E10000011.employment_public_sector.2023-12-01.Public sector employment":
    "95.8",

  "CSTM5160.employment_private_sector.2023-12-01.Private sector employment":
    "120.8",
  "E10000012.employment_private_sector.2023-12-01.Private sector employment":
    "450.2",
  "E10000011.employment_private_sector.2023-12-01.Private sector employment":
    "280.5",

  "CSTM5160.employment_self_employed.2023-12-01.Self-employed": "25.3",
  "E10000012.employment_self_employed.2023-12-01.Self-employed": "95.8",
  "E10000011.employment_self_employed.2023-12-01.Self-employed": "65.2",

  // Example 3: Population by age group (stacked)
  "CSTM5160.pop_0_17.2021-01-01.Aged 0-17": "45.2",
  "E10000012.pop_0_17.2021-01-01.Aged 0-17": "180.5",
  "E10000011.pop_0_17.2021-01-01.Aged 0-17": "95.8",

  "CSTM5160.pop_18_64.2021-01-01.Aged 18-64": "120.8",
  "E10000012.pop_18_64.2021-01-01.Aged 18-64": "450.2",
  "E10000011.pop_18_64.2021-01-01.Aged 18-64": "280.5",

  "CSTM5160.pop_65_plus.2021-01-01.Aged 65+": "25.3",
  "E10000012.pop_65_plus.2021-01-01.Aged 65+": "95.8",
  "E10000011.pop_65_plus.2021-01-01.Aged 65+": "65.2",
};

export default {
  reportTheme,
  items,
  indicatorValues,
  comparatorsList,
  comparatorAreaCodes,
};
